import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive"; // Import useMediaQuery
import "./animation1.css";

const InfiniteHorizontalScroll = () => {
  const isDesktopOrLarger = useMediaQuery({ minWidth: 640 }); // Define your breakpoint

  const [items, setItems] = useState([
    {
      image: "/img/webpImg/coin.webp",
      text: "Exclusive Offers from Your Favourite Online Stores",
    },
    { image: "/img/webpImg/coin.webp", text: "Don't Miss Out!" },
    { image: "/img/webpImg/coin.webp", text: "Top Deals, Just For You" },
    { image: "/img/webpImg/coin.webp", text: "Incredible Savings Await" },
    { image: "/img/webpImg/coin.webp", text: "Limited Time Offers" },
  ]);

  const scrollContainerRef = useRef(null);
  const scrollContentRef = useRef(null);

  useEffect(() => {
    if (!isDesktopOrLarger) return; // Only run effect if it's desktop

    const scrollContainer = scrollContainerRef.current;
    const scrollContent = scrollContentRef.current;

    if (!scrollContainer || !scrollContent) return;

    let animationFrameId;
    let scrollPosition = 0;

    const performScroll = () => {
      scrollPosition -= 1;

      if (Math.abs(scrollPosition) >= scrollContent.scrollWidth / 2) {
        scrollPosition = 0;
      }

      scrollContent.style.transform = `translateX(${scrollPosition}px)`;

      animationFrameId = requestAnimationFrame(performScroll);
    };

    animationFrameId = requestAnimationFrame(performScroll);

    const handleMouseEnter = () => {
      cancelAnimationFrame(animationFrameId);
    };

    const handleMouseLeave = () => {
      animationFrameId = requestAnimationFrame(performScroll);
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationFrameId);
      scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [isDesktopOrLarger]); // Add isDesktopOrLarger to dependency array

  if (!isDesktopOrLarger) {
    return null;
  }

  return (
    <div className="infinite-scroll-container-react" ref={scrollContainerRef}>
      <div className="infinite-scroll-content-react" ref={scrollContentRef}>
        {[...Array(4)].map((_, repeatIndex) =>
          items.map((item, index) => (
            <div
              key={`item-${repeatIndex}-${index}`}
              className="infinite-scroll-item-react"
            >
              <img
                src={item.image}
                alt="Offer icon"
                className="infinite-scroll-image-react"
              />
              <p className="infinite-scroll-text-react">{item.text}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default InfiniteHorizontalScroll;
